export default "__VITE_ASSET__CR71bFw0__"